import React, { useState, useEffect, useRef } from "react";

import Spreadsheet, {
  createFormulaParser,
  Matrix,
  CellBase,
} from "react-spreadsheet";

import { Link, useNavigate } from "react-router-dom";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";

//boostrap
import { Row, Button, Form, Modal } from "react-bootstrap";
//css
import "./CrudProducts.css";
//semantic ui
import { EditorState } from "draft-js";
import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";
import {
  ARRAYOFCountries,
  ARRAYOFCountriesAR,
  ARRAYOFCountriesDE,
  ARRAYOFCountriesNL,
} from "./CountriesArray";
import { toast } from "react-hot-toast";
import UnVerifiedAgentsApi from "../../Api/UnVerifiedAgentsApi";
import QRCode from "react-qr-code";
import { FaTrashAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
const AddProduct = () => {
  const [categories, setCategories] = useState([]);
  const [counrtyBarcode, setCounryBarcode] = useState([]);
  const [imgBackGounde, setImgBackGounde] = useState(null);

  const [Imgfile, setImgfile] = useState({
    Imgfile: null,
  });
  const [ImgfileComoanyInfo, setImgfileCompanyInfo] = useState({
    Imgfile: null,
  });
  const [ImgfileFrontLabel, setImgfileFrontLabel] = useState({
    Imgfile: null,
  });
  const [ImgfileBackLabel, setImgfileBackLabel] = useState({
    Imgfile: null,
  });
  const [ImgGallery, setImgGallery] = useState({
    ImgGallery: [],
  });
  const [values, setValues] = useState({
    cat: "",
    subCat: {
      en: "",
      ar: "",
      fr: "",
      ru: "",
      tur: "",
      cn: "",
      de: "",
      ir: "",
      dk: "",
    },
    countryOrigin: "",
    agents: "",
    materialProperty: "",
    peiceQty: {
      grossWeightForPeice: "",
      drainedWeightForPeice: "",
      netWeightForPeice: "",
      packageForPeice: "",
      freeOffer: "",
      usualWeight: "",
      unit: "",
    },
    supplierName: "",
    packageGrossWeight: "",
    unitForPackage: "",
    volume: "",
    width: "",
    height: "",
    tall: "",
    countInBox: "",
    stockOff: false,
    hidden: false,
    is_new: false,
    boxBarcode: {
      barcode: "",
    },
    pieceBarcode: {
      barcode: "",
    },
    canBarcode: {
      barcode: "",
    },

    barcodeCountry: "",
    palletCapacity: "",
    coverSticker: {
      count: null,
      type: "",
    },
    cartonSticker: "",
    productSticker: "",
    stickerLength: "",
    stickerWidth: "",
    components: {
      ar: "",
      en: "",
      de: "",
      fr: "",
      dk: "",
      nl: "",
      nor: "",
      tur: "",
      swe: "",
    },
    storageConditions: {
      ar: "",
      en: "",
      de: "",
    },
    notes: {
      ar: "",
      en: "",
      nl: "",
    },
    producingCompanyInfo: "",
    changeRate: "",
    madeIn: {
      ar: "",
      en: "",
      de: "",
    },
    productStatus: "",
    weightInPounds: "",
    productContainerCapacity: "",
    internationalNumber: "",
    room: "",
    weightCode: "",
    BrandCode: "",
    Brand: "",
    categoryCode: "",
    category: "",
    Weight: "",
    fill: "",
    fillCode: "",
    HsCode: "",
    agents: "",
  });
  const [nutritionalValueEn, setNutritionalValueEn] = useState(() =>
    EditorState.createEmpty()
  );
  const [nutritionalValueFr, setNutritionalValueFr] = useState(() =>
    EditorState.createEmpty()
  );
  const [nutritionalValueAl, setNutritionalValueAl] = useState(() =>
    EditorState.createEmpty()
  );
  const [nutritionalValueHl, setNutritionalValueHl] = useState(() =>
    EditorState.createEmpty()
  );

  //==================================Countries Drop Down Handling=================================
  const [value, setvalue] = useState("");
  const [value2, setvalue2] = useState("");
  const [images, setImages] = useState({
    boxImage: null,
    packageImage: null,
    itemImage: null,
  });
  const handlePdfChange = async (event) => { };
  // console.log(editorState)
  const handleImageChangeBarcode = async (event, imageKey) => {
    const file = event.target.files[0];
    const imageUrl = URL.createObjectURL(file);

    const formData = new FormData();
    formData.append("image", file);
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin-token")
    );
    try {
      const response = await fetch(
        "https://www.api.setalkel.co/product/barcode-image",
        {
          method: "POST",
          body: formData,
          headers: myHeaders,
        }
      );

      if (response.ok) {
        const { image } = await response.json();
        // console.log(image)
        setImages((prevImages) => ({
          ...prevImages,
          [imageKey]: image,
        }));
      } else {
        console.error("Failed to upload the image");
        // Handle error case
      }
    } catch (error) {
      console.error("Error occurred while uploading the image", error);
      // Handle error case
    }
  };
  // console.log(images)

  const handleOnchange = (val) => {
    setvalue(val);
    setValues({ ...values, countryOrigin: val.split("dashboard.product.,") });
  };
  const handleOnchangeAgents = (val) => {
    setvalue(val);
    setValues({ ...values, agents: val });
  };
  const handleOnchange2 = (val) => {
    setvalue2(val);
    setValues({
      ...values,
      materialProperty: val.split("dashboard.product.,"),
    });
  };
  //==================Image Gallery Handeling===============
  const handleGalleryChange = (e) => {
    const newImages = Array.from(e.target.files);

    setImgGallery((prevState) => {
      const allImages = [...prevState.ImgGallery, ...newImages];

      if (allImages.length > 4) {
        return {
          ImgGallery: allImages.slice(0, 4),
        };
      }
      return {
        ImgGallery: allImages,
      };
    });
  };

  //=======================Ingredients In  Input Handeling===============
  const productNameInputHandle = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      subCat: { ...values.subCat, [name]: value.toLowerCase() },
    });
  };

  const IngredientsInputHandle = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      components: { ...values.components, [name]: value.toLowerCase() },
    });
  };
  const StorageConditionsInputHandle = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      storageConditions: {
        ...values.storageConditions,
        [name]: value.toLowerCase(),
      },
    });
  };
  const NotesInputHandle = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      notes: { ...values.notes, [name]: value.toLowerCase() },
    });
  };
  //=======================Peice Quantity Input Handeling===============
  const peiceQuantityInputHandle = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      peiceQty: { ...values.peiceQty, [name]: value },
    });
  };
  const handelBrcodeBox = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      boxBarcode: { ...values.boxBarcode, [name]: value },
    });
  };
  const handelBrcodeCan = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      canBarcode: { ...values.canBarcode, [name]: value },
    });
  };
  const handelBrcodePiece = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      pieceBarcode: { ...values.pieceBarcode, [name]: value },
    });
  };
  const handelCoverSticker = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      coverSticker: { ...values.coverSticker, [name]: value },
    });
  };
  const MadeinInputHandle = (e) => {
    var { name, value } = e.target;

    setValues({
      ...values,
      madeIn: { ...values.madeIn, [name]: value },
    });
  };
  const [calculatedValue, setCalculatedValue] = useState();
  //=======================Input Handeling==============
  const handleInfoInputChange = (event) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    if (name === "width" || name === "height" || name === "tall") {
      const width = name === "width" ? value : values.width || 0;
      const height = name === "height" ? value : values.height || 0;
      const tall = name === "tall" ? value : values.tall || 0;

      const calculatedValue = (width * height * tall) / 1000000;

      setCalculatedValue(calculatedValue);
    }
  };

  //=======================Image Handeling===============
  const handleImageChange = (e) => {
    setImgfile({
      Imgfile: e.target.files[0],
    });
  };
  const handleImageChangeProductInfo = (e) => {
    setImgfileCompanyInfo({
      Imgfile: e.target.files[0],
    });
  };
  const handleImageChangeFrontLabel = (e) => {
    setImgfileFrontLabel({
      Imgfile: e.target.files[0],
    });
  };
  const handleImageChangeBackLabel = (e) => {
    setImgfileBackLabel({
      Imgfile: e.target.files[0],
    });
  };
  const handleImageChangeBack = (e) => {
    setImgBackGounde({
      Imgfile: e.target.files[0],
    });
  };
  const fileInputRef = useRef(null);
  const fileInputRefCompany = useRef(null);
  const fileInputFrontLabel = useRef(null);
  const fileInputBaclLabel = useRef(null);

  // console.log(ImgGallery.ImgGallery[0])
  //===================================Posting Image=====================
  const PostProductImg = async (id) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin-token")
      );
      const fd = new FormData();
      fd.append("image", Imgfile.Imgfile, Imgfile.Imgfile.name);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: fd,
        redirect: "follow",
      };

      const ImgResponse = await fetch(
        `https://www.api.setalkel.co/product/image/${id}`,
        requestOptions
      );
      const body = await ImgResponse.json();
      // console.log(body);
    } catch (error) {
      console.log(error);
    }
  };
  const { data: VerifiedAgents } = UnVerifiedAgentsApi.VerifiedAgentquery();
  const { data: UnVerifiedAgentquery } =
    UnVerifiedAgentsApi.UnVerifiedAgentquery();

  const [spreadsheetData, setSpreadsheetData] = useState(
    Array.from({ length: 6 }, () =>
      Array.from({ length: 2 }, () => ({ value: "" }))
    )
  );
  const [spreadsheetData2, setSpreadsheetData2] = useState(
    Array.from({ length: 6 }, () =>
      Array.from({ length: 2 }, () => ({ value: "" }))
    )
  );
  const [array, setArray] = useState([""]);
  const handleSpreadsheetChange = (data) => {
    setSpreadsheetData(data);
    const valuesArray = spreadsheetData.map((d) => d.map((d2) => d2.value));
    setArray(spreadsheetData.map((d) => d.map((d2) => d2.value).join("")));
  };
  const handleChange = (event) => {
    const { value, checked } = event.target;
    let newValues;
    if (checked) {
      newValues = [...values.agents, value];
    } else {
      newValues = values.agents.filter((agent) => agent !== value);
    }
    handleOnchangeAgents(newValues);
  };
  //=====================================Post Kitchen Gallery====================
  const PostProductGallery = async (id) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin-token")
      );
      if (ImgGallery.ImgGallery.length < 4) {
        const fd = new FormData();
        for (let i = 0; i < ImgGallery.ImgGallery.length; i++) {
          fd.append(
            "images",
            ImgGallery.ImgGallery[i],
            ImgGallery.ImgGallery[i].name
          );
        }
        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: fd,
          redirect: "follow",
        };

        const ImgResponse = await fetch(
          `https://www.api.setalkel.co/product/${id}/gallery`,
          requestOptions
        );
        const body = await ImgResponse.json();
        // console.log(body);
      } else {
        alert("dashboard.product.Gallery Images Should Be 4 Image");
      }
    } catch (error) {
      console.log(error);
    }
  };
  //===========================Post Product==============================

  const navigate = useNavigate();
  // console.log(array)
  const PostProduct = async (e) => {
    console.log(values.madeIn);
    e.preventDefault();
    // console.log(values.Notes)
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        `bearer ${localStorage.getItem("admin-token")}`
      );
      myHeaders.append("Content-Type", "application/json");

      var raw = {
        cat: values.cat,
        subCat: values.subCat,
        countryOrigin: values.countryOrigin,
        materialProperty: values.materialProperty,
        peiceQty: values.peiceQty,
        supplierName: values.supplierName,
        packageGrossWeight: values.packageGrossWeight,
        unitForPackage: "kg",
        volume: values.volume,
        countInBox: values.countInBox,
        stockOff: values.stockOff,
        hidden: values.hidden,
        is_new: values.is_new,
        barcodeCountry: values.barcodeCountry,
        palletCapacity: values.palletCapacity,
        barcodeCountry: values.barcodeCountry,
        nutritionalValue: array.filter((value) => value !== ""),
        components: values.components,
        notes: values.notes,
        storageConditions: values.storageConditions,
        producingCompanyInfo: values.producingCompanyInfo || "",
        changeRate: values.changeRate || "",
        productStatus: values.productStatus || "",
        weightInPounds: values.weightInPounds,
        madeIn: values.madeIn,
      };

      Object.keys(raw.madeIn).forEach((key) => {
        if (raw.madeIn[key] === "") delete raw.madeIn[key];
      });
      // Object.keys(raw.nutritionalValue).forEach(key => {
      //   if (raw.nutritionalValue[key] === "") delete raw.nutritionalValue[key];
      // });
      if (raw.nutritionalValue.length === 0) {
        delete raw.nutritionalValue;
      }
      Object.keys(raw.components).forEach((key) => {
        if (raw.components[key] === "") delete raw.components[key];
      });
      Object.keys(raw.notes).forEach((key) => {
        if (raw.notes[key] === "") delete raw.notes[key];
      });
      Object.keys(raw.storageConditions).forEach((key) => {
        if (raw.storageConditions[key] === "")
          delete raw.storageConditions[key];
      });
      // console.log(raw)
      if (values.stickerWidth) {
        raw.stickerWidth = values.stickerWidth;
      }
      if (values.stickerLength) {
        raw.stickerLength = values.stickerLength;
      }
      if (values.productSticker) {
        raw.productSticker = values.productSticker;
      }
      if (values.cartonSticker) {
        raw.cartonSticker = values.cartonSticker;
      }
      if (values.pieceBarcode.barcode || images.packageImage) {
        raw.pieceBarcode = {
          barcode: values.pieceBarcode.barcode,
          image: images.packageImage ? images.packageImage : undefined,
        };
      }
      if (values.boxBarcode.barcode || images.boxImage) {
        raw.boxBarcode = {
          barcode: values.boxBarcode.barcode,
          image: images.boxImage ? images.boxImage : undefined,
        };
      }
      if (values.canBarcode.barcode || images.itemImage) {
        raw.canBarcode = {
          barcode: values.canBarcode.barcode,
          image: images.itemImage ? images.itemImage : undefined,
        };
      }
      if (values.coverSticker.type !== "" || values.coverSticker.count) {
        raw.coverSticker = {
          count: values.coverSticker.count,
          type: values.coverSticker.type,
        };
      }
      let NewSubCat = raw.subCat;
      let NewComponents = raw.components;
      let NewPeiceQty = raw.peiceQty;
      let NewRaw = raw;

      Object.keys(NewComponents).forEach((key) => {
        if (NewComponents[key] === "") delete NewComponents[key];
      });
      Object.keys(NewSubCat).forEach((key) => {
        if (NewSubCat[key] === "") {
          delete NewSubCat[key];
        }
      });

      Object.keys(NewPeiceQty).forEach((key) => {
        if (NewPeiceQty[key] === "") {
          delete NewPeiceQty[key];
        }
      });

      Object.keys(NewRaw).forEach((key) => {
        if (NewRaw[key] === "") {
          delete NewRaw[key];
        }
      });

      if (NewComponents) {
        NewRaw.Components = NewComponents;
      }
      console.log(JSON.stringify(NewRaw));
      var raw2 = JSON.stringify(NewRaw);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(NewRaw),
        redirect: "follow",
      };

      const response = await fetch(
        "https://www.api.setalkel.co/product/",
        requestOptions
      );
      const body = await response.json();
      if (!response.ok) {
        toast.error("Product Not Added !!!!");
        // console.log(response);
        // console.log(body);
      } else {
        if (Imgfile.Imgfile) {
          await PostProductImg(body._id);
        }
        if (ImgGallery.ImgGallery.length > 0) {
          await PostProductGallery(body._id);
        }
        toast.success("Product Added Successfully");
        navigate("/dashboard/crproducts");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      const response = await fetch(
        "https://www.api.setalkel.co/product/cat/",
        requestOptions
      );
      const body = await response.json();
      // console.log(body);

      if (!response.ok) {
        setCategories([]);
        // console.log(body);
      } else {
        setCategories(body);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetcCountryforBarcode = async () => {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        `bearer ${localStorage.getItem("admin-token")}`
      );
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        "https://www.api.setalkel.co/export-country/info",
        requestOptions
      );
      const body = await response.json();
      // console.log(body);

      if (!response.ok) {
        setCounryBarcode([]);
        // console.log(body);
      } else {
        setCounryBarcode(body);
        // console.log(body)
      }
    };
    fetcCountryforBarcode();
  }, []);

  const customCreateFormulaParser = (data) =>
    createFormulaParser(data, { SUM: undefined });
  const customCreateFormulaParser2 = (data) =>
    createFormulaParser(data, { SUM: undefined });
  const [showModal, setShowModal] = useState(false);
  const [newUnit, setNewUnit] = useState("");
  const [unitOptions, setUnitOptions] = useState([
    "kg",
    "Liter",
    "gram",
    "ml",
    "m",
    "cm",
    "libra",
  ]);
  const [showModalPackage, setShowModalPackage] = useState(false);
  const [newPackage, setPackage] = useState("");
  const [PackageOptions, setPackageOptions] = useState([
    "plastic",
    "glass",
    "carton",
    "canned",
    "vacuum",
    "wood",
    "bag",
  ]);

  useEffect(() => {
    const savedUnits = localStorage.getItem("unitOptions");
    if (savedUnits) {
      setUnitOptions(JSON.parse(savedUnits));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("unitOptions", JSON.stringify(unitOptions));
  }, [unitOptions]);

  useEffect(() => {
    const savedPackage = localStorage.getItem("PackageOp");
    if (savedPackage) {
      setPackageOptions(JSON.parse(savedPackage));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("PackageOp", JSON.stringify(PackageOptions));
  }, [PackageOptions]);

  const handleAddUnit = () => {
    if (newUnit && !unitOptions.includes(newUnit)) {
      setUnitOptions([...unitOptions, newUnit]);
    }
    setShowModal(false);
    setNewUnit("dashboard.product.");
  };
  const handleAddPackage = () => {
    if (newPackage && !PackageOptions.includes(newUnit)) {
      setPackageOptions([...PackageOptions, newPackage]);
    }
    setShowModalPackage(false);
    setPackage("");
  };
  const { t } = useTranslation();
  return (
    <section className="cms-create-products">
      <Row>
        <div className="crud-products">
          <div className="crud-title">
            <h1>{t("dashboard.product.addProduct")}</h1>
          </div>
          <div className="crud-product">
            <h2>{t("dashboard.product.productsNames")}</h2>

            <Form onSubmit={PostProduct} className="products-form">
              <div className="product-langs">
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.en}>
                    {t("dashboard.product.productNameEn")}
                    <span style={{ color: "red" }}>
                      {t("dashboard.product.required")}
                    </span>
                  </Form.Label>
                  <Form.Control
                    name="en"
                    label={t("dashboard.product.product")}
                    value={values.subCat.en}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameEnPlaceholder"
                    )}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.ar}>
                    {t("dashboard.product.productNameAr")}
                    <span style={{ color: "red" }}>
                      {t("dashboard.product.required")}
                    </span>
                  </Form.Label>
                  <Form.Control
                    name="ar"
                    label={t("dashboard.product.product")}
                    value={values.subCat.ar}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameArPlaceholder"
                    )}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.fr}>
                    {t("dashboard.product.productNameFr")}
                  </Form.Label>
                  <Form.Control
                    name="fr"
                    label={t("dashboard.product.product")}
                    value={values.subCat.fr}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameFrPlaceholder"
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.ru}>
                    {t("dashboard.product.productNameRu")}
                  </Form.Label>
                  <Form.Control
                    name="ru"
                    label={t("dashboard.product.product")}
                    value={values.subCat.ru}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameRuPlaceholder"
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.de}>
                    {t("dashboard.product.productNameDe")}
                  </Form.Label>
                  <Form.Control
                    name="de"
                    label={t("dashboard.product.product")}
                    value={values.subCat.de}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameDePlaceholder"
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.cn}>
                    {t("dashboard.product.productNameCn")}
                  </Form.Label>
                  <Form.Control
                    name="cn"
                    label={t("dashboard.product.product")}
                    value={values.subCat.cn}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameCnPlaceholder"
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.tur}>
                    {t("dashboard.product.productNameTur")}
                  </Form.Label>
                  <Form.Control
                    name="tur"
                    label={t("dashboard.product.product")}
                    value={values.subCat.tur}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameTurPlaceholder"
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.ir}>
                    {t("dashboard.product.productNameIr")}
                  </Form.Label>
                  <Form.Control
                    name="ir"
                    label={t("dashboard.product.product")}
                    value={values.subCat.ir}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameIrPlaceholder"
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.dk}>
                    {t("dashboard.product.productNameDk")}
                  </Form.Label>
                  <Form.Control
                    name="dk"
                    label={t("dashboard.product.product")}
                    value={values.subCat.dk}
                    onChange={productNameInputHandle}
                    placeholder={t(
                      "dashboard.product.productNameDkPlaceholder"
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor={values.subCat.dk}>
                    {t("dashboard.product.productNameFi")}
                  </Form.Label>
                  <Form.Control
                    name="dk"
                    label={t("dashboard.product.product")}
                    style={{
                      border: "1px solid red",
                    }}
                    placeholder={t(
                      "dashboard.product.productNameFiPlaceholder"
                    )}
                  />
                </Form.Group>
              </div>

              <hr />
              <h2>{t("dashboard.product.one_piece_info")}</h2>
              <div className="d-flex gap-5 justify-content-start">
                <Form.Group>
                  <h5>{t("dashboard.product.country_origin")}</h5>
                  <div className="preview-values">{value}</div>
                  <MultiSelect
                    onChange={handleOnchange}
                    options={ARRAYOFCountries}
                    defaultValue={values.countryOrigin}
                  />
                </Form.Group>
                <div>
                  <h5>{t("dashboard.product.material_property")}</h5>
                  <Form.Group>
                    <div className="preview-values">{value2}</div>
                    <MultiSelect
                      onChange={handleOnchange2}
                      options={[
                        { label: t("dashboard.product.dried"), value: "dried" },
                        {
                          label: t("dashboard.product.frozen"),
                          value: "frozen",
                        },
                        { label: t("dashboard.product.mix"), value: "mix" },
                        {
                          label: t("dashboard.product.concert"),
                          value: "concert",
                        },
                      ]}
                      defaultValue={values.materialProperty}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="product-info">
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.product_category_website_required")}
                  </Form.Label>
                  <select
                    id="category-list"
                    name="cat"
                    className="m-0"
                    value={values.cat}
                    onChange={handleInfoInputChange}
                    required
                  >
                    <option>
                      {t("dashboard.product.please_choose_category")}
                    </option>
                    {categories.map((category, index) => {
                      return (
                        <option key={index} value={category._id}>
                          {category.en}
                        </option>
                      );
                    })}
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.product_category_alameen")}
                  </Form.Label>
                  <select
                    style={{ border: "1px solid red" }}
                    id="category-list"
                    name="cat"
                    className="m-0"
                  >
                    <option>
                      {t("dashboard.product.please_choose_category")}
                    </option>
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.product_category_website_required")}
                  </Form.Label>
                  <select
                    style={{ border: "1px solid red" }}
                    id="category-list"
                    name="cat"
                    className="m-0"
                    value={values.cat}
                    onChange={handleInfoInputChange}
                    required
                  >
                    <option>
                      {t("dashboard.product.please_choose_category")}
                    </option>
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.gross_weight_piece_required")}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    className="m-0"
                    name="grossWeightForPeice"
                    label="grossWeightForPeice"
                    value={values.peiceQty.grossWeightForPeice}
                    onChange={peiceQuantityInputHandle}
                    placeholder={t(
                      "dashboard.product.gross_weight_piece_required"
                    )}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.drained_weight_piece_required")}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="drainedWeightForPeice"
                    label="drainedWeightForPeice"
                    value={values.peiceQty.drainedWeightForPeice}
                    onChange={peiceQuantityInputHandle}
                    placeholder={t(
                      "dashboard.product.drained_weight_piece_required"
                    )}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.net_weight_piece_required")}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="netWeightForPeice"
                    label="netWeightForPeice"
                    value={values.peiceQty.netWeightForPeice}
                    onChange={peiceQuantityInputHandle}
                    placeholder={t(
                      "dashboard.product.net_weight_piece_required"
                    )}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.usual_weight")}</Form.Label>
                  <Form.Control
                    type="text"
                    name="usualWeight"
                    label="usualWeight"
                    value={values.peiceQty.usualWeight}
                    onChange={peiceQuantityInputHandle}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.free_quantity_included")}
                  </Form.Label>
                  <Form.Control
                    style={{ border: "1px solid red" }}
                    type="number"
                    name="freeOffer"
                    label="freeOffer"
                    value={values.peiceQty.freeOffer}
                    onChange={peiceQuantityInputHandle}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.piece_unit_required")}
                  </Form.Label>
                  <div className="d-flex align-items-center gap-2">
                    <select
                      id="category-list"
                      name="unit"
                      label="unit"
                      value={values.peiceQty.unit}
                      onChange={peiceQuantityInputHandle}
                      required
                    >
                      <option>
                        {t("dashboard.product.please_choose_unit")}
                      </option>
                      {unitOptions.map((unit, index) => (
                        <option key={index} value={unit}>
                          {unit}
                        </option>
                      ))}
                    </select>
                    <Button
                      variant="outline-danger"
                      style={{ marginLeft: "10px" }}
                      onClick={() => setShowModal(true)}
                    >
                      +
                    </Button>
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.weight_in_pounds")}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="weightInPounds"
                    label="weightInPounds"
                    value={values.weightInPounds}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.weight_in_pounds")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.product_package")}
                  </Form.Label>
                  <div className="d-flex align-items-center gap-2">
                    <select
                      id="category-list"
                      name="packageForPeice"
                      label="packageForPeice"
                      value={values.peiceQty.packageForPeice}
                      onChange={peiceQuantityInputHandle}
                    >
                      <option>
                        {t("dashboard.product.please_choose_package")}
                      </option>
                      {PackageOptions.map((Package, index) => (
                        <option key={index} value={Package}>
                          {Package}
                        </option>
                      ))}
                    </select>
                    <Button
                      variant="outline-danger"
                      style={{ marginLeft: "10px" }}
                      onClick={() => setShowModalPackage(true)}
                    >
                      +
                    </Button>
                  </div>
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label>
                    {t("dashboard.product.permissible_percentage")}
                  </Form.Label>
                  <Form.Control
                    name="changeRate"
                    label="changeRate"
                    value={values.changeRate}
                    onChange={handleInfoInputChange}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.product_status")}
                  </Form.Label>
                  <select
                    id="category-list"
                    name="productStatus"
                    label="productStatus"
                    value={values.productStatus}
                    onChange={handleInfoInputChange}
                  >
                    <option>
                      {t("dashboard.product.please_product_status")}
                    </option>
                    <option>{t("dashboard.product.hold")}</option>
                    <option>{t("dashboard.product.seasonal")}</option>
                    <option>{t("dashboard.product.limited_quantity")}</option>
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.product_company_info")}
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <Form.Control
                      type="file"
                      style={{ height: "fit-content", border: "1px solid red" }}
                      name="image"
                      id="productImg"
                      onChange={handleImageChangeProductInfo}
                      ref={fileInputRefCompany}
                    />
                    {ImgfileComoanyInfo.Imgfile && (
                      <div className="card-item-about position-relative">
                        <img
                          style={{ width: "100px", height: "100px" }}
                          src={URL.createObjectURL(ImgfileComoanyInfo.Imgfile)}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setImgfileCompanyInfo({ Imgfile: null });
                            if (fileInputRefCompany.current) {
                              fileInputRefCompany.current.value = "";
                            }
                          }}
                          style={{
                            position: "absolute",
                            top: "3px",
                            right: "30px",
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          X
                        </button>
                      </div>
                    )}
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.pallet_capacity")}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="capacity"
                    label="capacity"
                    value={values.capacity}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.pallet_capacity")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.product_number_from_manufacturer")}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="manufacturerProductNumber"
                    label="manufacturerProductNumber"
                    value={values.manufacturerProductNumber}
                    onChange={handleInfoInputChange}
                    placeholder={t(
                      "dashboard.product.product_number_from_manufacturer"
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("dashboard.product.recipe_number")}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="recipeNumber"
                    label="recipeNumber"
                    value={values.recipeNumber}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.recipe_number")}
                  />
                </Form.Group>
              </div>

              <div className="d-flex flex-column">
                <Form.Group style={{ width: "fit-content" }}>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.capacityWithoutPallet")}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="palletCapacity"
                    label={t("dashboard.product.uploadProductImage")}
                    style={{ border: "1px solid red" }}
                    placeholder={t("dashboard.product.uploadImage")}
                  />
                </Form.Group>
                <div className="d-flex gap-2 flex-wrap">
                  <Form.Group style={{ width: "fit-content" }}>
                    <Form.Label style={{ color: "red" }}>
                      {t("dashboard.product.container20Feet10Pallets")}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="palletCapacity"
                      label={t("dashboard.product.uploadProductImage")}
                      style={{ border: "1px solid red" }}
                      placeholder={t("dashboard.product.container20Feet10Pallets")}
                    />
                  </Form.Group>
                  <Form.Group style={{ width: "fit-content" }}>
                    <Form.Label style={{ color: "red" }}>
                      {t("dashboard.product.container20Feet11Pallets")}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="palletCapacity"
                      label={t("dashboard.product.uploadProductImage")}
                      style={{ border: "1px solid red" }}
                      placeholder={t("dashboard.product.container20Feet11Pallets")}
                    />
                  </Form.Group>
                  <Form.Group style={{ width: "fit-content" }}>
                    <Form.Label style={{ color: "red" }}>
                      {t("dashboard.product.container40Feet20Pallets")}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="palletCapacity"
                      label={t("dashboard.product.uploadProductImage")}
                      style={{ border: "1px solid red" }}
                      placeholder={t("dashboard.product.container40Feet20Pallets")}
                    />
                  </Form.Group>
                  <Form.Group style={{ width: "fit-content" }}>
                    <Form.Label style={{ color: "red" }}>
                      {t("dashboard.product.container40Feet21Pallets")}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="palletCapacity"
                      label={t("dashboard.product.uploadProductImage")}
                      style={{ border: "1px solid red" }}
                      placeholder={t("dashboard.product.container40Feet21Pallets")}
                    />
                  </Form.Group>
                </div>
              </div>
              <hr />
              <h4>
                {t("dashboard.product.productImage")}
                <span style={{ fontSize: "14px" }}>
                  {t("dashboard.product.productImageWithBackground")}
                </span>
              </h4>
              <div className="product-info">
                <Form.Group>
                  <Form.Label htmlFor="ProductImg">
                    {t("dashboard.product.uploadProductImage")}
                  </Form.Label>
                  <div style={{ display: "flex", gap: "5px" }}>
                    <Form.Control
                      type="file"
                      style={{ height: "fit-content" }}
                      name="image"
                      id="productImg"
                      onChange={handleImageChange}
                      ref={fileInputRef}
                    />
                    {Imgfile.Imgfile && (
                      <div className="card-item-about position-relative">
                        <img
                          style={{ width: "100px", height: "100px" }}
                          src={URL.createObjectURL(Imgfile.Imgfile)}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setImgfile({
                              Imgfile: null,
                            });
                            if (fileInputRef.current) {
                              fileInputRef.current.value = "";
                            }
                          }}
                          style={{
                            position: "absolute",
                            top: "3px",
                            right: "30px",
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    )}
                  </div>
                </Form.Group>

                <Form.Group>
                  <Form.Label htmlFor="productImg">
                    {t("dashboard.product.productImageGallery")}
                    <span style={{ color: "red" }}>
                      {t("dashboard.product.exactly4NoMoreNoLess")}
                    </span>
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <Form.Control
                      type="file"
                      name="images"
                      multiple
                      id="productImg"
                      onChange={handleGalleryChange}
                    />
                    <div style={{ display: "flex", gap: "5px" }}>
                      {ImgGallery.ImgGallery.map((image, index) => (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <img
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                            src={URL.createObjectURL(image)}
                            alt={`Gallery Img ${index + 1}`}
                          />
                          <button
                            type="button"
                            onClick={() => {
                              setImgGallery((prevState) => ({
                                ImgGallery: prevState.ImgGallery.filter(
                                  (_, indexIM) => indexIM !== index
                                ),
                              }));
                            }}
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-11px",
                              backgroundColor: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </Form.Group>
              </div>

              <hr />
              <h2>{t("dashboard.product.packageInfo")}</h2>
              <div className="Package">
                <Form.Group>
                  <Form.Label>{t("dashboard.product.packageGrossWeight")}</Form.Label>

                  <Form.Control
                    name="packageGrossWeight"
                    label="packageGrossWeight"
                    value={values.packageGrossWeight}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.packageGrossWeight")}
                    required
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.productBoxCBMVolume")}</Form.Label>

                  <Form.Control
                    name="volume"
                    label="volume"
                    value={values.volume}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.productBoxCBMVolume")}
                    required
                  />
                </Form.Group>
                <p
                  style={{
                    color: "1px solid black",
                    fontSize: "16px",
                  }}
                >
                  {t("dashboard.product.productBoxCBMVolume")}: {calculatedValue}
                </p>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.productBoxWidth")}
                  </Form.Label>

                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="width"
                    type="number"
                    min={0}
                    label="width"
                    value={values.width}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.productBoxCBMWidth")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.productBoxHeight")}
                  </Form.Label>

                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="height"
                    type="number"
                    min={0}
                    label="height"
                    value={values.height}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.productBoxCBMHeight")}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.productBoxTall")}
                  </Form.Label>

                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="tall"
                    type="number"
                    min={0}
                    label="tall"
                    value={values.tall}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.productBoxCBMTall")}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.productCountInBox")}</Form.Label>
                  <Form.Control
                    name="countInBox"
                    label="category"
                    value={values.countInBox}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.productCountInBox")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.productStockOff")}</Form.Label>

                  <select
                    id="category-list"
                    name="stockOff"
                    label="category"
                    value={values.stockOff}
                    onChange={handleInfoInputChange}
                  >
                    <option>{t("dashboard.product.chooseProductStockOff")}</option>
                    <option value="true">{t("dashboard.product.yes")}</option>
                    <option value="false">{t("dashboard.product.no")}</option>
                  </select>
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.stockQuantity")}</Form.Label>
                  <Form.Control
                    name="countInBox"
                    label="category"
                    style={{
                      border: "1px solid red",
                    }}
                    placeholder={t("dashboard.product.stockQuantity")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.productHidden")}</Form.Label>

                  <select
                    id="category-list"
                    name="hidden"
                    label="category"
                    value={values.hidden}
                    onChange={handleInfoInputChange}
                  >
                    <option>{t("dashboard.product.chooseIfProductHidden")}</option>
                    <option value="true">{t("dashboard.product.yes")}</option>
                    <option value="false">{t("dashboard.product.no")}</option>
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.isNewProduct")}</Form.Label>

                  <select
                    id="category-list"
                    name="is_new"
                    label="category"
                    value={values.is_new}
                    onChange={handleInfoInputChange}
                  >
                    <option>{t("dashboard.product.chooseIfProductNew")}</option>
                    <option value="true">{t("dashboard.product.yes")}</option>
                    <option value="false">{t("dashboard.product.no")}</option>
                  </select>
                </Form.Group>
              </div>
              <h2>{t("dashboard.product.barcodeInfo")}</h2>

              <div className="box-barcode">
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.brandCode")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="BrandCode"
                    label="BrandCode"
                    value={values.BrandCode}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.brandCode")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>{t("dashboard.product.brand")}</Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="Brand"
                    label="Brand"
                    value={values.Brand}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.brand")}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.categoryCode")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="categoryCode"
                    label="categoryCode"
                    value={values.categoryCode}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.categoryCode")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.category")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="category"
                    label="category"
                    value={values.category}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.category")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.weightCode")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="weightCode"
                    label="weightCode"
                    value={values.weightCode}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.weightCode")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.weight")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="Weight"
                    label="Weight"
                    value={values.Weight}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.weight")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.package")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="fill"
                    label="fill"
                    value={values.fill}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.package")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.internationalNumber")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="internationalNumber"
                    label="HsCode"
                    value={values.internationalNumber}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.internationalNumber")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.productCategoryGSI")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="room"
                    label="room"
                    value={values.room}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.packing")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.boxBarcode")}</Form.Label>
                  <Form.Control
                    name="barcode"
                    label="Box Barcode"
                    value={values.boxBarcode.barcode}
                    onChange={handelBrcodeBox}
                    placeholder={t("dashboard.product.boxBarcode")}
                  />
                </Form.Group>
                {values.boxBarcode.barcode != "" && (
                  <Form.Group>
                    <div
                      style={{
                        height: "auto",
                        margin: "0 auto",
                        maxWidth: 64,
                        width: "100%",
                      }}
                    >
                      <QRCode
                        size={256}
                        style={{
                          height: "auto",
                          maxWidth: "100%",
                          width: "100%",
                          marginTop: "10px",
                        }}
                        value={values.boxBarcode.barcode}
                        viewBox={`0 0 256 256`}
                      />
                    </div>
                  </Form.Group>
                )}
              </div>
              <div className="box-barcode">
                <Form.Group>
                  <Form.Label>{t("dashboard.product.canBarcode.label")}</Form.Label>
                  <Form.Control
                    name="barcode"
                    label={t("dashboard.product.canBarcode.barcode")}
                    value={values.canBarcode.barcode}
                    onChange={handelBrcodeCan}
                    placeholder={t("dashboard.product.canBarcode.placeholder")}
                  />
                </Form.Group>
                {values.canBarcode.barcode && (
                  <Form.Group>
                    <div
                      style={{
                        height: "auto",
                        margin: "0 auto",
                        maxWidth: 64,
                        width: "100%",
                      }}
                    >
                      <QRCode
                        size={256}
                        style={{
                          height: "auto",
                          maxWidth: "100%",
                          width: "100%",
                          marginTop: "10px",
                        }}
                        value={values.canBarcode.barcode}
                        viewBox={`0 0 256 256`}
                      />
                    </div>
                  </Form.Group>
                )}
              </div>

              <div className="box-barcode">
                <Form.Group>
                  <Form.Label>{t("dashboard.product.pieceBarcode.label")}</Form.Label>
                  <Form.Control
                    name="barcode"
                    label={t("dashboard.product.pieceBarcode.barcode")}
                    value={values.pieceBarcode.barcode}
                    onChange={handelBrcodePiece}
                    placeholder={t("dashboard.product.pieceBarcode.placeholder")}
                  />
                </Form.Group>
                {values.pieceBarcode.barcode && (
                  <Form.Group>
                    <div
                      style={{
                        height: "auto",
                        margin: "0 auto",
                        maxWidth: 64,
                        width: "100%",
                      }}
                    >
                      <QRCode
                        size={256}
                        style={{
                          height: "auto",
                          maxWidth: "100%",
                          width: "100%",
                          marginTop: "10px",
                        }}
                        value={values.pieceBarcode.barcode}
                        viewBox={`0 0 256 256`}
                      />
                    </div>
                  </Form.Group>
                )}

                <Form.Group>
                  <Form.Label>{t("dashboard.product.barcodeCountry.label")}</Form.Label>
                  <select
                    id="category-list"
                    name="barcodeCountry"
                    className="m-0"
                    value={values.barcodeCountry}
                    onChange={handleInfoInputChange}
                  >
                    <option>{t("dashboard.product.barcodeCountry.placeholder")}</option>
                    {ARRAYOFCountries.map((d, index) => (
                      <option key={index} value={d.label}>
                        {d.label}
                      </option>
                    ))}
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{ color: "red" }}>
                    {t("dashboard.product.hsCode.label")}
                  </Form.Label>
                  <Form.Control
                    style={{
                      border: "1px solid red",
                    }}
                    name="HsCode"
                    label={t("dashboard.product.hsCode.label")}
                    value={values.HsCode}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.hsCode.placeholder")}
                  />
                </Form.Group>
              </div>

              <h2 style={{ marginTop: "20px" }}>{t("dashboard.product.stickerInfo.header")}</h2>
              <div className="product">
                <Form.Group>
                  <Form.Label>{t("dashboard.product.stickerInfo.cartonStickerCount")}</Form.Label>
                  <Form.Control
                    type="number"
                    name="cartonSticker"
                    label={t("dashboard.product.stickerInfo.cartonStickerCount")}
                    value={values.cartonSticker}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.stickerInfo.cartonStickerCount")}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.stickerInfo.coverStickerCount")}</Form.Label>
                  <Form.Control
                    type="number"
                    name="count"
                    label={t("dashboard.product.stickerInfo.coverStickerCount")}
                    value={values.coverSticker.count}
                    onChange={handelCoverSticker}
                    placeholder={t("dashboard.product.stickerInfo.coverStickerCount")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.stickerInfo.coverStickerType")}</Form.Label>
                  <select
                    id="category-list"
                    name="type"
                    label={t("dashboard.product.stickerInfo.coverStickerType")}
                    value={values.coverSticker.type}
                    onChange={handelCoverSticker}
                  >
                    <option>{t("dashboard.product.stickerInfo.coverStickerType")}</option>
                    <option>{t("dashboard.product.coverStickerTypes.small")}</option>
                    <option>{t("dashboard.product.coverStickerTypes.big")}</option>
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.stickerInfo.frontLabelLength")}</Form.Label>
                  <Form.Control
                    type="number"
                    name="stickerLength"
                    label={t("dashboard.product.stickerInfo.frontLabelLength")}
                    value={values.stickerLength}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.stickerInfo.frontLabelLength")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.stickerInfo.frontLabelWidth")}</Form.Label>
                  <Form.Control
                    name="stickerWidth"
                    type="number"
                    label={t("dashboard.product.stickerInfo.frontLabelWidth")}
                    value={values.stickerWidth}
                    onChange={handleInfoInputChange}
                    placeholder={t("dashboard.product.stickerInfo.frontLabelWidth")}
                  />
                </Form.Group>
              </div>

              <div className="product">
                <Form.Group>
                  <Form.Label>{t("dashboard.product.back_label_length")}</Form.Label>
                  <Form.Control
                    style={{ border: "1px solid red" }}
                    type="number"
                    name="productSticker"
                    label={t("dashboard.product.barcode_country")}
                    placeholder={t("dashboard.product.back_label_placeholder")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.back_label_width")}</Form.Label>
                  <Form.Control
                    style={{ border: "1px solid red" }}
                    type="number"
                    name="productSticker"
                    label={t("dashboard.product.barcode_country")}
                    placeholder={t("dashboard.product.back_label_width_placeholder")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.cover_sticker_number")}</Form.Label>
                  <Form.Control
                    style={{ border: "1px solid red" }}
                    type="number"
                    name="productSticker"
                    label={t("dashboard.product.barcode_country")}
                    placeholder={t("dashboard.product.cover_sticker_number_placeholder")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.lid_label_type")}</Form.Label>
                  <select
                    id="category-list"
                    name="type"
                    label="type"
                    style={{ border: "1px solid red" }}
                  >
                    <option>{t("dashboard.product.please_choose_lid_label_type")}</option>
                    <option>{t("dashboard.product.small")}</option>
                    <option>{t("dashboard.product.middle")}</option>
                    <option>{t("dashboard.product.big")}</option>
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor="ProductImg" style={{ color: "red" }}>
                    {t("dashboard.product.front_label_image")}
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <Form.Control
                      type="file"
                      style={{ height: "fit-content", border: "1px solid red" }}
                      name="image"
                      id="productImg"
                      onChange={handleImageChangeFrontLabel}
                      ref={fileInputFrontLabel}
                    />
                    {ImgfileFrontLabel.Imgfile && (
                      <div className="card-item-about position-relative">
                        <img
                          style={{ width: "100px", height: "100px" }}
                          src={URL.createObjectURL(ImgfileFrontLabel.Imgfile)}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setImgfileFrontLabel({
                              Imgfile: null,
                            });
                            if (fileInputFrontLabel.current) {
                              fileInputFrontLabel.current.value = "";
                            }
                          }}
                          style={{
                            position: "absolute",
                            top: "3px",
                            right: "30px",
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    )}
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label htmlFor="ProductImg" style={{ color: "red" }}>
                    {t("dashboard.product.back_label_image")}
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <Form.Control
                      type="file"
                      style={{ height: "fit-content", border: "1px solid red" }}
                      name="image"
                      id="productImg"
                      onChange={handleImageChangeBackLabel}
                      ref={fileInputBaclLabel}
                    />
                    {ImgfileBackLabel.Imgfile && (
                      <div className="card-item-about position-relative">
                        <img
                          style={{ width: "100px", height: "100px" }}
                          src={URL.createObjectURL(ImgfileBackLabel.Imgfile)}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setImgfileBackLabel({
                              Imgfile: null,
                            });
                            if (fileInputBaclLabel.current) {
                              fileInputBaclLabel.current.value = "";
                            }
                          }}
                          style={{
                            position: "absolute",
                            top: "3px",
                            right: "30px",
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    )}
                  </div>
                </Form.Group>
              </div>
              <h4 style={{ marginTop: "20px" }}>
                {t("dashboard.product.nutritional_values_info")}
              </h4>
              <div className="d-flex gap-4">
                <div
                  style={{ border: "2px solid red", padding: "5px" }}
                  className="d-flex flex-column"
                >
                  <Form.Label>{t("dashboard.product.nutritional_values_us_au")}</Form.Label>
                  <Spreadsheet
                    data={spreadsheetData}
                    createFormulaParser={customCreateFormulaParser}
                    onChange={handleSpreadsheetChange}
                    style={{ border: "2px solid red" }}
                  />
                </div>
                <div
                  className="d-flex flex-column"
                  style={{
                    border: "1px solid red",
                    padding: "5px",
                  }}
                >
                  <Form.Label>{t("dashboard.product.nutritional_values_eu")}</Form.Label>
                  <Spreadsheet
                    data={spreadsheetData2}
                    createFormulaParser={customCreateFormulaParser2}
                    onChange={handleSpreadsheetChange}
                    style={{ border: "2px solid red" }}
                  />
                </div>
              </div>

              <h4
                style={{
                  marginTop: "20px",
                }}
              >
                {t("dashboard.product.ingredients_info")}
              </h4>
              <div className="groub-of-editor">
                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_en")}</Form.Label>
                  <Form.Control
                    name="en"
                    label={t("dashboard.product.ingredients_en")}
                    value={values.components.en}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_en")}
                    style={{ textRendering: "auto" }}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_ar")}</Form.Label>
                  <Form.Control
                    name="ar"
                    label={t("dashboard.product.ingredients_ar")}
                    value={values.components.ar}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_ar")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_fr")}</Form.Label>
                  <Form.Control
                    name="fr"
                    label={t("dashboard.product.ingredients_fr")}
                    value={values.components.fr}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_fr")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_de")}</Form.Label>
                  <Form.Control
                    name="de"
                    label={t("dashboard.product.ingredients_de")}
                    value={values.components.de}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_de")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_dk")}</Form.Label>
                  <Form.Control
                    name="dk"
                    label={t("dashboard.product.ingredients_dk")}
                    value={values.components.dk}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_dk")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_nl")}</Form.Label>
                  <Form.Control
                    name="nl"
                    label={t("dashboard.product.ingredients_nl")}
                    value={values.components.nl}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_nl")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_nor")}</Form.Label>
                  <Form.Control
                    name="nor"
                    label={t("dashboard.product.ingredients_nor")}
                    value={values.components.nor}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_nor")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_swe")}</Form.Label>
                  <Form.Control
                    name="swe"
                    label={t("dashboard.product.ingredients_swe")}
                    value={values.components.swe}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_swe")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_tur")}</Form.Label>
                  <Form.Control
                    name="tur"
                    label={t("dashboard.product.ingredients_tur")}
                    value={values.components.tur}
                    onChange={IngredientsInputHandle}
                    placeholder={t("dashboard.product.ingredients_placeholder_tur")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.ingredients_fi")}</Form.Label>
                  <Form.Control
                    name="tur"
                    label={t("dashboard.product.ingredients_fi")}
                    style={{
                      border: "1px solid red",
                    }}
                    placeholder={t("dashboard.product.ingredients_placeholder_fi")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
              </div>
              <h4
                style={{
                  marginTop: "20px",
                }}
              >
                {t("dashboard.product.storage_conditions_info")}
              </h4>
              <div className="product">
                <Form.Group>
                  <Form.Label>{t("dashboard.product.storage_conditions_en")}</Form.Label>
                  <Form.Control
                    name="en"
                    label={t("dashboard.product.storage_conditions_en")}
                    value={values.storageConditions.en}
                    onChange={StorageConditionsInputHandle}
                    placeholder={t("dashboard.product.storage_conditions_placeholder_en")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.storage_conditions_ar")}</Form.Label>
                  <Form.Control
                    name="ar"
                    label={t("dashboard.product.storage_conditions_ar")}
                    value={values.storageConditions.ar}
                    onChange={StorageConditionsInputHandle}
                    placeholder={t("dashboard.product.storage_conditions_placeholder_ar")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.storage_conditions_de")}</Form.Label>
                  <Form.Control
                    name="de"
                    label={t("dashboard.product.storage_conditions_de")}
                    value={values.storageConditions.de}
                    onChange={StorageConditionsInputHandle}
                    placeholder={t("dashboard.product.storage_conditions_placeholder_de")}
                    as="textarea"
                    row={3}
                  />
                </Form.Group>
              </div>

              <h4
                style={{
                  marginTop: "20px",
                }}
              >
                {t("dashboard.product.notes")}{" "}
                <span
                  style={{
                    fontSize: "12px",
                  }}
                >
                  {t("dashboard.product.notes_if_any")}
                </span>
              </h4>
              <div className="product">
                <Form.Group>
                  <Form.Label>{t("dashboard.product.notes_in_en")}</Form.Label>
                  <Form.Control
                    name="en"
                    value={values.notes.en}
                    onChange={NotesInputHandle}
                    placeholder={t("dashboard.product.notes_placeholder_en")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.notes_in_ar")}</Form.Label>
                  <Form.Control
                    name="ar"
                    value={values.notes.ar}
                    onChange={NotesInputHandle}
                    placeholder={t("dashboard.product.notes_placeholder_ar")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t("dashboard.product.notes_in_nl")}</Form.Label>
                  <Form.Control
                    name="nl"
                    value={values.notes.nl}
                    onChange={NotesInputHandle}
                    placeholder={t("dashboard.product.notes_placeholder_nl")}
                  />
                </Form.Group>
              </div>
              <hr />
              <h4>{t("dashboard.product.made_in")}</h4>
              <div
                className="product"
                style={{
                  padding: "5px",
                }}
              >
                <Form.Group
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Form.Label>{t("dashboard.product.made_in_en")}</Form.Label>
                  <select
                    name="en"
                    className="p-2"
                    value={values.madeIn.en}
                    onChange={MadeinInputHandle}
                    placeholder={t("dashboard.product.made_in_en")}
                    style={{
                      border: "1px solid #9ca3af",
                      borderRadius: "8px",
                    }}
                  >
                    <option>{t("dashboard.product.please_choose_a_country")}</option>
                    {ARRAYOFCountries.map((d, index) => {
                      return (
                        <option key={index} value={d.label}>
                          {d.label}
                        </option>
                      );
                    })}
                  </select>
                </Form.Group>

                <Form.Group
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Form.Label>{t("dashboard.product.made_in_ar")}</Form.Label>
                  <select
                    name="ar"
                    className="p-2"
                    value={values.madeIn.ar}
                    onChange={MadeinInputHandle}
                    placeholder={t("dashboard.product.made_in_ar")}
                    style={{
                      border: "1px solid #9ca3af",
                      borderRadius: "8px",
                    }}
                  >
                    <option>{t("dashboard.product.please_choose_a_country")}</option>
                    {ARRAYOFCountriesAR.map((category, index) => {
                      return (
                        <option key={index} value={category.value}>
                          {category.value}
                        </option>
                      );
                    })}
                  </select>
                </Form.Group>

                <Form.Group>
                  <Form.Label>{t("dashboard.product.made_in_nl")}</Form.Label>
                  <select
                    name="nl"
                    className="p-2"
                    value={values.madeIn.nl}
                    onChange={MadeinInputHandle}
                    placeholder={t("dashboard.product.made_in_nl")}
                    style={{
                      border: "1px solid #9ca3af",
                      borderRadius: "8px",
                    }}
                  >
                    <option>{t("dashboard.product.please_choose_a_country")}</option>
                    {ARRAYOFCountriesNL.map((category, index) => {
                      return (
                        <option key={index} value={category.label}>
                          {category.label}
                        </option>
                      );
                    })}
                  </select>
                </Form.Group>

                <Form.Group
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Form.Label>{t("dashboard.product.made_in_de")}</Form.Label>
                  <select
                    name="de"
                    className="p-2"
                    style={{
                      border: "1px solid red",
                      borderRadius: "8px",
                    }}
                    placeholder={t("dashboard.product.made_in_de")}
                  >
                    <option>{t("dashboard.product.please_choose_a_country")}</option>
                    {ARRAYOFCountriesDE.map((category, index) => {
                      return (
                        <option key={index} value={category.label}>
                          {category.label}
                        </option>
                      );
                    })}
                  </select>
                </Form.Group>
              </div>

              <Form.Group
                style={{
                  width: "fit-content",
                }}
              >
                <Form.Label htmlFor="ProductImg" style={{ color: "red" }}>
                  {t('dashboard.product.print_files')}
                </Form.Label>
                <Form.Control
                  style={{ border: "1px solid red" }}
                  type="file"
                  name="image"
                  id="productImg"
                  onChange={(event) => handlePdfChange(event)}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label style={{ color: "red" }}>
                  {t('dashboard.product.name_of_agent_on_product_cover')}
                </Form.Label>
                <div>
                  <h4>{t('dashboard.product.verified_agents')}</h4>
                  <div className="agent-prod">
                    {VerifiedAgents?.map((agent) => (
                      <Form.Check
                        key={agent.value}
                        type="checkbox"
                        label={agent.name}
                        value={agent.value}
                        checked={values.agents.includes(agent.value)}
                        onChange={handleChange}
                      />
                    ))}
                  </div>
                  <hr />
                  <h4>{t('dashboard.product.unverified_agents')}</h4>
                  <div className="agent-prod">
                    {UnVerifiedAgentquery?.map((agent) => (
                      <Form.Check
                        key={agent.value}
                        type="checkbox"
                        label={agent.name}
                        value={agent.value}
                        checked={values.agents.includes(agent.value)}
                        onChange={handleChange}
                      />
                    ))}
                  </div>
                </div>
              </Form.Group>
              <hr />
              <div
                style={{
                  width: "100%",
                  height: "200px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h4>{t('dashboard.product.prices')}</h4>
              </div>
              <Button type="submit" variant="warning">
                {t('dashboard.product.add_new_product')}
              </Button>
            </Form>
          </div>
        </div>
      </Row>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('dashboard.product.add_new_unit')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>{t('dashboard.product.new_unit')}</Form.Label>
            <Form.Control
              type="text"
              value={newUnit}
              onChange={(e) => setNewUnit(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t('dashboard.product.close')}
          </Button>
          <Button variant="warning" onClick={handleAddUnit}>
            {t('dashboard.product.add')}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalPackage} onHide={() => setShowModalPackage(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('dashboard.product.add_new_product_package')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>{t('dashboard.product.new_package')}</Form.Label>
            <Form.Control
              type="text"
              value={newPackage}
              onChange={(e) => setPackage(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalPackage(false)}>
            {t('dashboard.product.close')}
          </Button>
          <Button variant="warning" onClick={handleAddPackage}>
            {t('dashboard.product.add')}
          </Button>
        </Modal.Footer>
      </Modal>

    </section>
  );
};

export default AddProduct;
